import { Stack, Alert, AlertTitle } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import CategoryDto from '../../models/CategoryDto';
import ItemDto from '../../models/ItemDto';
import { useRestaurantData } from '../../provider/RestaurantDataContext';
import { useTranslation } from 'react-i18next';
import { SEARCH_PARAM } from '../../utils/Constants';
import { useMemo } from 'react';
import ItemListCardItem from '../menuCard/subCategoryPage/ItemListCardItem';

export type ItemDtoSearch = ItemDto & {
    categoryId: number;
    subCategoryId: number;
}

export default function SearchResultPage() {
    const { t } = useTranslation();
    const { restaurantData, restaurantData: { currency } } = useRestaurantData();
    const [searchParams] = useSearchParams();

    const searchKey = searchParams.get(SEARCH_PARAM) || '';
    const items = useMemo(() => {
        const allItems: ItemDtoSearch[] = [];
        restaurantData.categories.forEach((category: CategoryDto) => {
            category.subCategories.forEach(subCategory =>
                subCategory.items.filter(item => item.value.value.toLowerCase().indexOf(searchKey.toLowerCase()) !== -1).forEach(item => {
                    if (allItems.filter(itemToCheck => itemToCheck.id === item.id).length === 0)
                        allItems.push({ ...item, categoryId: category.id, subCategoryId: subCategory.id });
                }
                ));
        });
        return allItems;
    }, [restaurantData.categories, searchKey]);

    if (!restaurantData || !restaurantData.id) {
        return (
            <Alert severity="error">
                <>
                    <AlertTitle>{t('errorMessageTitle')}</AlertTitle>
                    No Data from Server
                </>
            </Alert>
        );
    }

    return (
        <>
            {
                items.length > 0 &&
                <Stack spacing={1} style={{ marginTop: '1rem' }}>
                    {
                        items.map((item: ItemDtoSearch) => {
                            return (
                                <ItemListCardItem
                                    item={item}
                                    currency={currency}
                                    key={item.id}
                                    categoryId={item.categoryId}
                                    subCategoryId={item.subCategoryId}
                                />);
                        })

                    }
                </Stack>
            }
            {
                items.length === 0 &&
                <Alert severity="info" sx={{ marginTop: '1rem' }}>
                    <>
                        <AlertTitle>Fehler</AlertTitle>
                        {`${t('searchErrorMessage', { searchValue: searchKey })}`}
                    </>
                </Alert>
            }
        </>
    );
}